export default "__VITE_ASSET__PzyVrh93__"